import { render } from "./SideBar.vue?vue&type=template&id=4f78fbfc&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=4f78fbfc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f78fbfc"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QList from 'quasar/src/components/item/QList.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QToolbar,QToolbarTitle,QItem,QItemLabel,QBtn,QIcon,QItemSection,QList});qInstall(script, 'directives', {Ripple});
